const REGEX_ALLOWED_PROTOCOLS = /^https?:\/\//;

export default function(host) {
  return host == null || REGEX_ALLOWED_PROTOCOLS.test(host)
    ? host
    : `https://${host}`;
}
